exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-attachment {\n  display: inline-block;\n}\n.upload-attachment__input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n.upload-attachment__label {\n  display: block;\n  margin-bottom: 0.5rem;\n}", ""]);

// exports
